var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 5.234c.247 0 .446.2.446.446v2.701a.445.445 0 1 1-.892 0v-2.7c0-.248.199-.447.446-.447zm.312-1.927c.089.08.134.195.134.311a.42.42 0 0 1-.134.313.419.419 0 0 1-.312.133.378.378 0 0 1-.169-.035.323.323 0 0 1-.143-.098.42.42 0 0 1-.134-.313c0-.062.009-.116.036-.169a.3.3 0 0 1 .098-.142c.16-.17.455-.17.624 0z"
  })));
};
export default SvgInfoCircle;